<template>
  <el-dialog
    title="编辑分组联络员"
    :visible.sync="dialogInfo.flag"
    :close-on-click-modal="false"
    destroy-on-close
    width="600px"
  >
    <el-form
      :model="memberInfo"
      ref="ruleForm"
      :rules="rules"
      label-width="100px"
      class="form"
      size="small"
    >
      
      <el-form-item label="单位及职务：" prop="unitPosition">
        <el-input
          type="textarea"
          placeholder="请输入单位及职务"
          v-model="memberInfo.unitPosition"
          maxlength="255"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="房间号：" prop="roomNumber">
        <el-input
          placeholder="请输入房间号"
          v-model="memberInfo.roomNumber"
          maxlength="50"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="handleClose(false)" title="取消"></butn>
      <butn btntype="primary" @click="submitForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";

import { updateLiaisonInfo } from "@/api/groupManage.js"

export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {
          flag: false,
          member: {},
        };
      },
    },
  },
  data() {
    return {
      memberInfo: {
        uuid: "",
        roomNumber: "",
        unitPosition: "",
      },
      rules: {
        unitPosition: [{ required: true, message: "请输入单位及职务" }],
      },
    };
  },
  mounted() {
    const {
      uuid,
      unitPosition,
      roomNumber
    } = this.dialogInfo.member;
    this.memberInfo = {
      uuid,
      unitPosition,
      roomNumber
    };
  },
  methods: {
    handleClose(flag = false) {
      let refreshFlag = typeof flag === 'boolean' ? flag : false;
      this.$emit("close", refreshFlag);
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          updateLiaisonInfo(this.memberInfo).then(({ code, msg }) => {
            if (code !== 0) return;
            this.$message.success(msg);
            this.handleClose(true);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}
</style>